module.exports = __webpack_public_path__ + "57c9436f2590e0b8b5cd8d5652450936.svg";